<template>
	<div id="prizelist" class="page">
		<div class="prizelist">
			<div class="prize" v-for="item in prizeList" v-on:click="event_submit(item)">
				<img v-bind:src="item.image"/>
			</div>
		</div>
	</div>
</template>

<script>
import { Toast } from 'we-vue'
export default {
  data () {
    return {
		prizeList:[]
	}
  },
  mounted () {
	
  },
  created(){
	this.$app.pr('api/prize/lists').then((res) => {
		this.prizeList = res.data.prizeList
	})
  },
  methods:{
	  	event_submit(item){
			this.$store.state.prizeChecked = item
			this.$wx.navigateBack()
		}
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	#prizelist{
		background-color:#f4fcff;
		min-height:100vh;
	}
	.prizelist{
		padding:3vw;
	}
	.prizelist .prize{
		display:inline-block;
		width:45.5vw;
		border-radius:3vw;
		box-shadow:0px 0px 6px #CCCCCC;
		margin-bottom:3vw;
	}
	.prizelist .prize img{
		width:100%;
		height:25vw;
	}
	.prizelist .prize:nth-child(2n){
		margin-left:3vw;
	}
</style>


// WEBPACK FOOTER //
// src/components/Prizelist.vue